import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'

import classnames from 'classnames'
import { AnyAction, bindActionCreators } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { useTheme } from 'styled-components/native'

import { AlertBannerTypes } from '@lyrahealth-inc/shared-app-logic/src/features/alerts/AlertBannerTypes'
import { CARE_ADVISOR_DISPLAY_PHONE_NUMBER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import NotificationBanner, {
  ContentAlignment,
} from '@lyrahealth-inc/ui-core/lib/atoms/notificationBanner/NotificationBanner'
import { AlertBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/alertBanner/AlertBanner'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { toJS } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/hocs/toJS'

import styles from './banners.module.scss'
import { getCustomerPhone } from '../../../../data/customer/customerSelectors'
import { closeMicrositeBanner } from '../../data/micrositeActions'
import { getIsMicrositeBannerDismissed } from '../../data/micrositeSelectors'

interface RacialStressBannerProps {
  generalSupportNumber: string
  displayRacialStressBanner: boolean
  closeMicrositeBanner: () => ThunkAction<Promise<void>, Map<string, any>, unknown, AnyAction>
  actions: { closeMicrositeBanner: () => void }
}

const RacialStressBanner = ({
  actions: { closeMicrositeBanner },
  generalSupportNumber = CARE_ADVISOR_DISPLAY_PHONE_NUMBER,
  displayRacialStressBanner,
}: RacialStressBannerProps) => {
  const { isAuroraTheme } = useTheme()
  const bannerMessage = (
    <FormattedMessage
      defaultMessage='<strong>If you are experiencing racial stress</strong>, please
            call (800) 640-7721 (6:30am - 5pm PT M-F) for assistance in finding a provider. For all other support, call
            {generalSupportNumber} or email care@lyrahealth.com.'
      description='Text in a banner about how to get help if experiencing racial stress'
      values={{
        generalSupportNumber,
        strong: (text: string) => (
          <strong
            className={isAuroraTheme ? undefined : styles['strong-text-semi-bold']}
            style={isAuroraTheme ? { fontWeight: 600 } : undefined}
          >
            {text}
          </strong>
        ),
      }}
    />
  )

  if (isAuroraTheme) {
    return displayRacialStressBanner ? (
      <AlertBanner
        show
        style={AlertBannerTypes.INFO}
        contents={bannerMessage}
        textSize={BodyTextSize.DEFAULT}
        minHeight='0px'
        includeX
        dismissHandler={closeMicrositeBanner}
        containerZIndex={9}
      />
    ) : null
  }

  return (
    displayRacialStressBanner && (
      <NotificationBanner
        // @ts-expect-error TS(2769): No overload matches this call.
        level='microsite-info'
        contentAlignment={ContentAlignment.CENTER}
        closeBannerCTA={closeMicrositeBanner}
        closeBannerBtnCustomClass={styles['close-banner-btn']}
        notifications={[
          <div key='n1' className={classnames(styles['top-banner'], styles['microsite-info'])}>
            {bannerMessage}
          </div>,
        ]}
      />
    )
  )
}

const mapStateToProps = ($$state: any) => {
  return {
    generalSupportNumber: getCustomerPhone($$state),
    displayRacialStressBanner: !getIsMicrositeBannerDismissed($$state),
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: bindActionCreators({ closeMicrositeBanner }, dispatch),
  }
}

// @ts-expect-error TS(2345): Argument of type '(wrappedComponentProps: RacialSt... Remove this comment to see the full error message
export default connect(mapStateToProps, mapDispatchToProps)(toJS(RacialStressBanner))
